import { NavLink } from 'react-router-dom';
import { MOBILE_NAV_ITEMS } from '@/config/navigation';
import { cn } from '@/lib/cn';

/**
 * Mobile bottom-tab nav. Hidden on desktop. Sits above the iOS home indicator
 * thanks to padding-bottom on <body> reading safe-area-inset-bottom.
 */
export function MobileBottomNav() {
  return (
    <nav
      className="sticky bottom-0 z-30 grid auto-cols-fr grid-flow-col border-t border-kw-border bg-white pb-[var(--safe-area-inset-bottom)] md:hidden"
      aria-label="Primary"
    >
      {MOBILE_NAV_ITEMS.map((item) => (
        <NavLink
          key={item.id}
          to={item.href}
          className={({ isActive }) =>
            cn(
              'flex flex-col items-center justify-center gap-1 py-2 text-[11px] font-medium transition-colors',
              isActive ? 'text-kw-cerulean' : 'text-kw-muted hover:text-kw-shark',
            )
          }
        >
          <item.icon className="size-[22px]" />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
